import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createRouterScroller } from 'vue-router-better-scroller'
import { Collapse, CollapseItem } from 'vant';
// import '@/utils/rem.js'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from "vue-awesome-swiper";
import "tailwindcss/tailwind.css"
import { DropdownMenu, DropdownItem,Form, Field, CellGroup ,Pagination } from 'vant';
import './app.less'

// Vant 桌面端适配
import '@vant/touch-emulator'

/* --------------------------------
Vant 中有个别组件是以函数的形式提供的，
包括 Toast，Dialog，Notify 和 ImagePreview 组件。
在使用函数组件时，unplugin-vue-components
无法自动引入对应的样式，因此需要手动引入样式。
------------------------------------- */
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(router)
app.use(pinia)
app.use(Collapse);
app.use(CollapseItem);
// 增强了 Vue Router v4 的滚动行为
app.use(createRouterScroller({
  selectors: {
    'window': true,
    'body': true,
    '.scrollable': true,
  },
})).use(VueAwesomeSwiper);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Pagination);


app.mount('#app')
